// extracted by mini-css-extract-plugin
export default {"assignee-type-content-switcher":"urmkOW"};